import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import styled, { keyframes } from "styled-components";
import EditIcon from "./icon/EditIcon";
import CheckIcon from "./icon/CheckIcon2";
import RemoveIcon from "./icon/Cross";
import DownloadIcon from "./icon/DownloadIcon";
import LoadingSpinner from "./dev/LoadingSpinner";
import StyleLink from "./dev/StyleLink";
import Span from "./dev/Span";
import { CopyToClipboard } from "react-copy-to-clipboard";
import ShareIcon from "./icon/ShareIcon";
import convertDate from "./dev/convertDate";
import Select from './dev/Select';
import ProposalInfo from './Proposal/ProposalInfo'

const { REACT_APP_URI = "/" } = process.env;
class Proposal extends Component {
    state = {
        id: -1,
        title: "",
        myProposalOrNot: false,
        channels: [],
        fields: "",
        categories: {
            channelType: true,
            subscriberCount: true,
            totalViewCount: true,
            avgEngageRate: true,
            videoCount: true,
            recentAvgViewCount: true,
            recentAvgEngageRate: true,
            twoMonthAvgViewCount: true,
            twoMonthAvgEngageRate: true,
            twoMonthVideoCount: true,
            todaySubscriberCount: false,
            todaySubscriberRate: false,
            todayViewCount: false,
            todayViewRate: false,
            monthSubscriberCount: false,
            monthSubscriberRate: false,
            monthViewCount: true,
            monthViewRate: false
        },
        addInputValue: "",
        addError: "",
        isTitleEdit: false,
        editedTitle: "",
        isChannelDelete: false,
        isShare: false,
        deletedChannel: {},
        isLoading: true,
        shareTypeCode: "",
        shareExpireDate: "",
        copied: false,
        access: true,
        sortArgs: {
            sortRule: "descending",
            sortCategory: ""
        },
        isDownloading: false
    };
    componentDidMount() {
        this.getProposal("loading");
    }
    categoriesToBinaryCode = () => { //物件轉換二進制字串
        const {categories} = this.state
        const BinaryCode = Object.values(categories)
        .reverse() //後端二進制開碼反了 只好這樣做
        .map(category => {
            if (category) return "1";
            else return "0";
        })
        .reduce((acc, cur) => acc + cur);
        return BinaryCode
    }
    BinaryCodeToCategories = (fields) => { //二進制字串轉換物件
        const reverseField = fields.split("").reduce((revString, char)=> char + revString, "");
        //後端二進制開碼反了 只好這樣做
        const categoriesState = 
            Object.keys(this.state.categories)
                .reduce((categories, key, index)=>({...categories,[key]: reverseField.toString()[index] === '1'}),{})
        return categoriesState
    }
    getProposal = condition => {
        condition === "loading" && this.setState({ isLoading: true });
        const { proposalId } = this.props.match.params;
        const { BinaryCodeToCategories} = this

        fetch(`${REACT_APP_URI}/api/Proposal/${proposalId}/?version=2`, {
            credentials: "include"
        }) //現在排序會依照資料庫記的來排 所以sort應該不用傳了
            .then(res => {
                const { status } = res;
                if (status === 200) return res.json();
                throw this.setState({ access: false });
            })
            .then(res => {
                const categoriesState = BinaryCodeToCategories(res.fields)
                this.setState({
                    ...res,
                    editedTitle: res.title,
                    isTitleEdit: false,
                    isLoading: false,
                    sortArgs: {
                        sortRule: res.sortRule,
                        sortCategory: res.sortCategory
                    },
                    shareTypeCode: res.currentPermission,
                    shareExpireDate: res.publicDueTime,
                    categories: categoriesState
                });
            });
    };
    downloadProposal = () => {
        this.setState({ isDownloading: true });
        const {
            state: {
                id,
                title,
                categories,
                sortArgs: { sortRule, sortCategory }
            }
        } = this;
        const fields = Object.values(categories) //這邊在形成二進制並反轉 *excel 需反轉
            .reverse()
            .map(category => {
                if (category) return "1";
                else return "0";
            })
            .reduce((acc, cur) => acc + cur);
        fetch(`${REACT_APP_URI}/downloadProposal/${id}?fields=${fields}&sortRule=${sortRule}&sortCategory=${sortCategory}&version=2`,
            { credentials: "include" })
            .then(res => res.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `${title}.xlsx`;
                a.click();
                this.setState({ isDownloading: false });
            });
    };
    sortRuleSelect = ({ value = "" }) =>
        this.setState(
            { sortArgs: { ...this.state.sortArgs, sortRule: value } },
            () => this.sendSortCondtion()
        ); //送排序條件給後端
    sortCategorySelect = ({ value = "" }) =>{
        this.setState(
            { sortArgs: { ...this.state.sortArgs, sortCategory: value } },
            () => this.sendSortCondtion()
        ); //送排序條件給後端
    }
    sendSortCondtion = () => { //記憶排序條件
        const {
            state: { id },
            props: {
                user: { token },
            }
        } = this;
        fetch(`${REACT_APP_URI}/memoryProposalSort/${id}`, {
            method: "post",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": token
            },
            body: JSON.stringify({
                sortCategory: this.state.sortArgs.sortCategory,
                sortRule: this.state.sortArgs.sortRule
            })
        }).then(res => {
            const { status } = res;
            if (status === 200) {
                this.getProposal("loading");
            }
        });
    };
    toggleCategoey = condition => {
        const {
            sendCategoriesCondition
        } = this;
        this.setState({ categories: {...this.state.categories, [condition]: !this.state.categories[condition]}}, () => sendCategoriesCondition(condition))
    };
    sendCategoriesCondition = (condition) => { // 記憶 categories
        const {
            state: { id, categories },
            props: {
                user: { token }
            },
            categoriesToBinaryCode
        } = this;
        const BinaryCode = categoriesToBinaryCode(categories)
        fetch(`${REACT_APP_URI}/memoryProposalFields/${id}`, {
            method: "post",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": token
            },
            body: JSON.stringify({
                fields: BinaryCode
            })
        })
        .then(() => {
            if (condition === this.state.sortArgs.sortCategory) {
                //如果他把現在排序的項目取消 就把排序設成預設: 依時間排序
                this.sortCategorySelect({ value: ''});
            }
        });
    }
    addInput = e => this.setState({ addInputValue: e.target.value });
    addSubmit = () => {
        const {
            props: {
                messages,
                user: { token }
            },
            state: { id, addInputValue },
            getProposal
        } = this;
        fetch(`${REACT_APP_URI}/addChannelToProposal/${id}`, {
            method: "post",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": token
            },
            body: JSON.stringify({
                url: addInputValue
            })
        }).then(res => {
            const { status } = res;
            if (status === 200) {
                this.setState({ addError: "" });
                getProposal();
            } else {
                if (status === 400)
                    this.setState({
                        addError: messages.proposal_id_find_nothing
                    });
                if (status === 611)
                    this.setState({
                        addError: messages.proposal_id_find_added
                    });
                if(status === 503)
                    this.setState({
                        addError: messages.ranking_youtube_quota_error
                    });
            }
        });
    };
    toggleTitleEdit = () =>
        this.setState({ isTitleEdit: !this.state.isTitleEdit });
    editTitleInput = e => this.setState({ editedTitle: e.target.value });
    editTitleSubmit = () => {
        const {
            user: { token }
        } = this.props;
        const {
            state: { id, editedTitle },
            getProposal
        } = this;
        fetch(`${REACT_APP_URI}/api/Proposal/${id}/`, {
            method: "put",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": token
            },
            body: JSON.stringify({
                title: editedTitle
            })
        }).then(res => {
            const { status } = res;
            if (status === 200) getProposal();
        });
    };
    toggleDelete = channel =>
        this.setState({
            isChannelDelete: !this.state.isChannelDelete,
            deletedChannel: channel
        });
    deleteSubmit = infoId => {
        const {
            state: { id },
            props: {
                user: { token }
            },
            getProposal,
            toggleDelete
        } = this;
        fetch(`${REACT_APP_URI}/removeChannelFromProposal/${id}`, {
            method: "post",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": token
            },
            body: JSON.stringify({
                id: infoId
            })
        }).then(res => {
            const { status } = res;
            if (status === 200) {
                toggleDelete("");
                getProposal("loading");
            }
        });
    };
    toggleShare = () => this.setState({ isShare: !this.state.isShare });
    shareTypeSelect = ({ value = "" }) => {
        this.setState({ shareTypeCode: value }, () => this.sendShareType()); //送分享給後端
    }
    sendShareType = () => {
        const {
            props: {
                user: { token }
            },
            state: { id, shareTypeCode },
            getProposal
        } = this;
        fetch(`${REACT_APP_URI}/changeAccessPermission/${id}`, {
            method: "post",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": token
            },
            body: JSON.stringify({
                accessPermission: parseInt(shareTypeCode, 10)
            })
        }).then(res => {
            const { status } = res;
            if (status === 200) {
                this.setState({ addError: "" });
                getProposal();
            }
        });
    };
    numberNormalization = (value, category) => {
        if (isNaN(value)) return value;
        if (category.includes("Rate")) {
            return value + "%";
        } else {
            return Number(value).toLocaleString();
        }
    };
    getCategoriesLength = () => {
        const { categories } = this.state;
        let categoriesLength = Object.values(categories)
            .map(value => {
                if (value) return 1;
                else return 0;
            })
            .reduce((acc, cur) => acc + cur);
        return categoriesLength;
    };
    renderTopField = () => {
        const {
            state: {
                title,
                isTitleEdit,
                editedTitle,
                myProposalOrNot,
                isDownloading
            },
            props: { messages },
            toggleTitleEdit,
            editTitleInput,
            editTitleSubmit,
            downloadProposal,
            toggleShare
        } = this;
        return (
            <Content between>
                <Content>
                    {!isTitleEdit && <ProposalTitle>{title}</ProposalTitle>}
                    {isTitleEdit && (
                        <ProposalTitleInput
                            autoFocus
                            value={editedTitle}
                            onInput={editTitleInput}
                            onKeyPress={e =>
                                e.key === "Enter" && editTitleSubmit()
                            }
                        />
                    )}
                    {myProposalOrNot && (
                        <EditIconWrap onClick={() => toggleTitleEdit()}>
                            <EditIcon size={15} />
                        </EditIconWrap>
                    )}
                </Content>
                <Content>
                    {!isDownloading && (
                        <DownloadWrap onClick={() => downloadProposal()}>
                            <DownloadIcon />
                            {messages.proposal_id_download}
                        </DownloadWrap>
                    )}
                    {isDownloading && <LoadingSpinner size={"15px"} />}
                    {myProposalOrNot && (
                        <ShareIconWrap onClick={() => toggleShare()}>
                            <ShareIcon />
                            {messages.proposal_id_share}
                        </ShareIconWrap>
                    )}
                </Content>
            </Content>
        );
    };
    renderCategory = category => {
        const {
            props: { messages },
            toggleCategoey
        } = this;
        const [key, value] = category;
        return (
            <CategoryCheck onClick={() => toggleCategoey(key)} isCheck={value}>
                {messages[`${key}`]}
                <CheckIcon />
            </CategoryCheck>
        );
    };
    renderCategoryField = () => {
        const {
            state: { categories },
            props: { messages },
            renderCategory
        } = this;
        const idInfo = Object.entries(categories).slice(0, 5);
        const idPerform = Object.entries(categories).slice(5, 10);
        const idGrowthToday = Object.entries(categories).slice(10, 14);
        const idGrowthMonth = Object.entries(categories).slice(
            14,
            categories.length
        );
        return (
            <CategoryWrap>
                <CategoryTittle>{messages.proposal_id_info}</CategoryTittle>
                <CategoryContent>
                    {idInfo.map(category => renderCategory(category))}
                </CategoryContent>
                <CategoryTittle>{messages.proposal_id_perform}</CategoryTittle>
                <CategoryContent>
                    <CategoryContent column>
                        <CategoryContent>
                            {idPerform.map(category =>
                                renderCategory(category)
                            )}
                        </CategoryContent>
                    </CategoryContent>
                </CategoryContent>
                <CategoryTittle>{messages.proposal_id_growth}</CategoryTittle>
                <CategoryContent>
                    <CategoryContent column>
                        <CategoryContent>
                            {idGrowthToday.map(category =>
                                renderCategory(category)
                            )}
                        </CategoryContent>
                        <CategoryContent>
                            {idGrowthMonth.map(category =>
                                renderCategory(category)
                            )}
                        </CategoryContent>
                    </CategoryContent>
                </CategoryContent>
            </CategoryWrap>
        );
    };
    renderMiddleField = () => {
        const {
            sortCategorySelect,
            sortRuleSelect,
            addInput,
            addSubmit,
            state: {
                addInputValue,
                addError,
                categories,
                sortArgs: { sortRule, sortCategory }
            },
            props: { messages }
        } = this;
        const sortCategoryType = Object.entries(categories)
            .filter(([key, value]) => Boolean(value))
            .map(([key, value]) => {
                return {
                    value: key,
                    label: messages[`${key}`],
                    clearableValue: false
                };
            })
            .concat([{
                value: "",
                label: messages.proposal_id_time_sort,
                clearableValue: false
            }]) // 新增依時間選項
        const CategoryLabel = sortCategoryType.find(i => i.value === sortCategory) !== undefined
            ? sortCategoryType.find(i => i.value === sortCategory).label
            : sortCategoryType.find(i => i.value === '').label
        const sortRuleType = [
            {
                value: 'descending',
                label: messages.info_list_sort_high,
                clearableValue: false
            },
            {
                value: 'ascending',
                label: messages.info_list_sort_low,
                clearableValue: false
            }
        ];
        return (
            <MiddleField>
                <Content color={"#de0606"}>
                    <ChannelAddInput
                        type={"text"}
                        placeholder={messages.proposal_id_add}
                        value={addInputValue}
                        onInput={addInput}
                        onKeyPress={e => e.key === "Enter" && addSubmit()}
                    />
                    <ChannelAddSubmit onClick={() => addSubmit()}>
                        <CheckIcon />
                    </ChannelAddSubmit>
                    {addError}
                </Content>
                <Content>
                    <StyledSelect
                        value={sortCategory}
                        onChange={sortCategorySelect}
                        options={sortCategoryType}
                        placeholder={CategoryLabel}
                        // id="sort"
                        isSearchable={false}
                        margin='0 8px 0 0'
                    />
                    <Select
                        // value={sortRule}
                        onChange={sortRuleSelect}
                        options={sortRuleType}
                        placeholder={sortRuleType.find(i => i.value === sortRule).label}
                        // id="sort"
                        isSearchable={false}
                    />
                </Content>
            </MiddleField>
        );
    };
    renderCreatorPart = () => {
        const {
            state: { channels, myProposalOrNot },
            toggleDelete
        } = this;
        const { messages } = this.props;
        return (
            <CreatorWrap>
                <ChannelContent bar category={"title"}>
                    {messages.channel_name}
                </ChannelContent>
                {channels.map(channel => {
                    return (
                        <ChannelContent category={"titleContent"}>
                            {myProposalOrNot && (
                                <DeleteButton
                                    onClick={() => toggleDelete(channel)}
                                >
                                    <RemoveIcon />
                                </DeleteButton>
                            )}
                            <Avatar imgUrl={channel.avatar} />
                            <StyleLink
                                to={`/Info/${channel.id}`}
                                target={"_blank"}
                            >
                                <Span subTitle>{channel.title}</Span>
                            </StyleLink>
                        </ChannelContent>
                    );
                })}
            </CreatorWrap>
        );
    };
    renderValuePart = () => {
        const {
            state: { channels, categories },
            props: { messages },
            getCategoriesLength,
            numberNormalization
        } = this;
        let channelCategoriesKey = Object.entries(categories).map(
            ([key, value]) => {
                if (value)
                    return <ChannelContent bar>{messages[key]}</ChannelContent>;
                else return "";
            }
        );
        return (
            <ValuesWrap columns={getCategoriesLength()}>
                {channelCategoriesKey}
                {channels.map(channel => {
                    return Object.entries(categories).map(([key, value]) => {
                        if (value)
                            return (
                                <ChannelContent category={key}>
                                    {numberNormalization(channel[key], key)}
                                </ChannelContent>
                            );
                        else return "";
                    });
                })}
            </ValuesWrap>
        );
    };
    renderChannels = () => {
        const { renderCreatorPart, renderValuePart, state:{ isLoading} } = this;
        return (
            <React.Fragment>
                {isLoading ? <LoadingSpinner/> 
                    : <ChannelsWrap>
                    {renderCreatorPart()}
                    {renderValuePart()}
                </ChannelsWrap>}
            </React.Fragment>
        );
    };
    renderChannelDelete = () => {
        const {
            state: {
                deletedChannel: { id, title }
            },
            props: { messages },
            deleteSubmit,
            toggleDelete
        } = this;
        return (
            <React.Fragment>
                <Mask />
                <DeleteWrap>
                    <div>
                        <span>{messages.proposal_list_confirm_delete}</span>
                        <span>"{title}"?</span>
                    </div>
                    <DeleteRightPart>
                        <span onClick={() => deleteSubmit(id)}>
                            {messages.delete}
                        </span>
                        <span onClick={() => toggleDelete("")}>
                            {messages.cancel}
                        </span>
                    </DeleteRightPart>
                </DeleteWrap>
            </React.Fragment>
        );
    };
    renderShare = () => {
        const {
            state: { id, shareTypeCode, shareExpireDate, copied },
            props: { messages },
            toggleShare,
            shareTypeSelect
        } = this;
        const shareType = [
            {
                value: 1,
                label: messages.proposal_id_share_me,
                clearableValue: false
            },
            {
                value: 2,
                label: messages.proposal_id_share_team,
                clearableValue: false
            },
            {
                value: 3,
                label: messages.proposal_id_share_all,
                clearableValue: false
            }
        ];
        return (
            <React.Fragment>
                <Mask />
                <ShareWrap>
                    <Select
                        // value={shareTypeCode} //一個state
                        onChange={shareTypeSelect} //一個function 選到的時候要做啥
                        options={shareType} //選項有哪些
                        placeholder={messages.proposal_id_share_team}
                        id="sort"
                        minWidth='240px'
                    />
                    <Content margin={"18px 0 0 0px"}>
                        <ShareLink>{`www.intered.co/Proposal/${id}`}</ShareLink>
                        {copied === false && (
                            <CopyToClipboard
                                onCopy={() =>
                                    this.setState({ copied: true }, () =>
                                        setTimeout(() => {
                                            this.setState({ copied: false });
                                        }, 1000)
                                    )
                                }
                                text={`www.intered.co/Proposal/${id}`}
                            >
                                <ShareCopy>
                                    {messages.proposal_id_share_copy}
                                </ShareCopy>
                            </CopyToClipboard>
                        )}
                        {copied === true && (
                            <ShareCopy>
                                <CheckIcon />
                            </ShareCopy>
                        )}
                    </Content>
                    {shareTypeCode === 3 && (
                        <Content color={"#de0606"} margin={"2px 0 0 0px"}>
                            {convertDate(shareExpireDate)}
                            {` ${messages.proposal_id_share_back}`}
                            {` ${messages.proposal_id_share_team}`}
                        </Content>
                    )}
                    <Finish onClick={() => toggleShare()}>
                        {messages.contact_confirm}
                    </Finish>
                    {/*這邊寫確定紐關掉*/}
                </ShareWrap>
            </React.Fragment>
        );
    };
    renderErrorPage = () => {
        const { messages } = this.props;
        return (
            <ErrorWrap>
                <Title>
                    <div>{messages["proposal_id_share_no_access_1"]}</div>
                    <div>{messages["proposal_id_share_no_access_2"]}</div>
                </Title>
                <SubTitle>
                    <div>{messages["404_comingsoon_01"]}</div>
                    <div>{messages["404_comingsoon_02"]}</div>
                    <div>{messages["404_comingsoon_03"]}</div>
                </SubTitle>
                <StyleLink to={`/Pricing`} target={"_blank"}>
                    <Content center>
                        <ReadMore>{messages["404_learn_more"]}</ReadMore>
                    </Content>
                </StyleLink>
            </ErrorWrap>
        );
    };
    render() {
        const {
            state: {
                myProposalOrNot,
                isChannelDelete,
                isLoading,
                isShare,
                access
            },
            renderTopField,
            renderCategoryField,
            renderMiddleField,
            renderChannels,
            renderChannelDelete,
            renderShare,
            renderErrorPage
        } = this;
        return (
            <Container isLoading={isLoading}>
                {access ? (
                    // isLoading ? (
                    //     <LoadingWrap>
                    //         <LoadingSpinner />
                    //     </LoadingWrap>
                    // ) : (
                        (
                        <Wrap>
                            {renderTopField()}
                            {myProposalOrNot && renderCategoryField()}
                            {myProposalOrNot && renderMiddleField()}
                            {renderChannels()}
                            {myProposalOrNot &&
                                isChannelDelete &&
                                renderChannelDelete()}
                            {myProposalOrNot && isShare && renderShare()}
                            {/*<ProposalInfo/> 尚未開發完成，先註解掉*/}
                        </Wrap>
                    )
                ) : (
                    renderErrorPage()
                )}
            </Container>
        );
    }
}
const mapStateToProps = state => {
    return {
        user: state.User,
        messages: state.Messages
    };
};
export default withRouter(connect(mapStateToProps)(Proposal));
const Loading = keyframes`
    0%, 100% {
        opacity: .15;
    }
    50% {
        opacity: .05;
    }
`;
const Mask = styled.div`
    position: fixed;
    justify-content: center;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 4999;
    background-color: rgba(0, 0, 0, 0.6);
    cursor: pointer;
    transition: all 2s ease-in-out;
`;
const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    /* min-height: 100vh; */
    height: ${({ isLoading }) => (isLoading ? "100vh" : "auto")};
    padding: 50px 0 120px 0;
    background-color: #fafafa;
    border-left: 1px solid #e6e6e6;
    overflow: scroll;
    @media (max-width: 900px) {
        align-items: initial;
    }
`;
const Wrap = styled.div`
    display: flex;
    flex-direction: column;
    width: 900px;
`;
const Content = styled.div`
    display: flex;
    ${({ column }) =>
        column
            ? "flex-direction: column; justify-content: center;"
            : "align-items: center;"}
    ${({ margin }) => (margin ? `margin: ${margin}` : "")}
    ${({ padding }) => (padding ? `padding: ${padding}` : "")}
    ${({ color }) => (color ? `color: ${color}` : "")}
    ${({ between }) => (between ? "justify-content: space-between" : "")}
    ${({ center }) => (center ? `justify-content: center;` : "")}
`;
const ProposalTitle = styled.div`
    display: flex;
    align-items: center;
    font-size: 24px;
    font-weight: 500;
    color: #787878;
`;
const ProposalTitleInput = styled.input`
    padding-left: 5px;
    border: solid 1px #dedede;
    font-size: 22px;
    font-weight: 500;
    color: #999999;
    &:focus {
        border: solid 1px #999999;
        outline: none;
    }
`;
const EditIconWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 25px;
    margin-left: 10px;
    cursor: pointer;
`;
const CategoryWrap = styled.div`
    display: grid;
    grid-row-gap: 10px;
    grid-template: auto auto auto / auto 1fr;
    width: 100%;
    padding: 24px 0 14px 24px;
    margin-top: 20px;
    background-color: #fff;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);
`;
const CategoryTittle = styled.div`
    display: flex;
    white-space: nowrap;
`;
const CategoryContent = styled.div`
    display: flex;
    flex-wrap: wrap;
    ${({ column }) => (column ? "flex-direction: column" : "")};
    color: #787878;
    font-size: 14px;
    font-weight: 500;
`;
const CategoryCheck = styled.div`
    display: flex;
    align-items: center;
    border: solid 0.5px #979797;
    padding: 3px 8px;
    margin: 0 6px 10px 6px;
    font-size: 12px;
    font-weight: 300;
    white-space: nowrap;
    cursor: pointer;
    svg {
        margin-left: 6px;
        path {
            ${({ isCheck }) => (isCheck ? "fill: #de0606" : "fill: #e6e6e6")}
        }
    }
`;
const MiddleField = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
`;
const ChannelAddInput = styled.input`
    width: 250px;
    height: 100%;
    padding-left: 5px;
    border: solid 1px #dedede;
    border-radius: 4px 0 0 4px;
    font-size: 14px;
    font-weight: 300;
    color: #999999;
    &:focus {
        border: solid 1px #999999;
        outline: none;
    }
    &::placeholder {
        text-align: center;
    }
`;
const ChannelAddSubmit = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0 4px 4px 0;
    height: 100%;
    margin-right: 10px;
    padding: 10px;
    background-color: #de0606;
    cursor: pointer;
    svg {
        path {
            fill: #fff;
        }
    }
`;
const CreatorWrap = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 400px;
    margin-top: 20px;
    border-right: 0.5px solid #fff;
`;
const ValuesWrap = styled.div`
    display: grid;
    grid-template: ${({ columns }) =>
        columns ? `1fr / repeat(${columns}, auto);` : ""};
    overflow-x: scroll;
    margin-top: 20px;
`;
const ChannelsWrap = styled.div`
    width: 900px;
    display: flex;
`;
const ChannelContent = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 70px;
    background-color: #fff;
    padding: 10px 20px;
    word-break: keep-all;
    white-space: nowrap;
    ${({ bar }) =>
        bar
            ? "min-height: auto; height: auto; border-bottom: 0; border-right: 1px solid #fff; background-color: #de0606; color: #fff"
            : "border-bottom: 1px solid #e6e6e6;"}
    ${({ category }) =>
        category === "title"
            ? "min-width: 400px; word-break: break-all; white-space: normal"
            : category === "titleContent"
            ? "min-width: 400px; padding: 10px 0; word-break: break-all; white-space: normal; justify-Content: flex-start;"
            : category === "channelType"
            ? "min-width: 160px"
            : ""}
`;
const Avatar = styled.div`
    position: relative;
    border-radius: 100%;
    min-width: 48px;
    height: 48px;
    margin-left: 8px;
    margin-right: 16px;
    border-radius: 100%;
    background-image: url('${props => props.imgUrl}');
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
    ${props =>
        props.isLoading
            ? `color: transparent; background-image: none; background-color: #787878; animation: ${Loading} 2s infinite;`
            : ""}
`;
const DeleteButton = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 48px;
    padding: 0 20px;
    cursor: pointer;
    svg {
        path {
            fill: #de0606;
        }
    }
`;
const DeleteWrap = styled.div`
    position: fixed;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-width: 640px;
    padding: 0 0 0 40px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 5000;
    font-size: 20px;
    font-weight: 500;
    background-color: #e94242;
    color: #fff;
    transition: all 0.2s ease-in-out;
`;
const DeleteRightPart = styled.div`
    display: flex;
    justify-content: space-around;
    padding: 20px;
    font-weight: 300;
    span:nth-child(1) {
        margin-right: 20px;
    }
    span:hover {
        font-weight: 500;
        text-decoration: underline;
        cursor: pointer;
    }
`;
const DownloadWrap = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    svg {
        margin-right: 5px;
    }
`;

const ShareIconWrap = styled.div`
    display: flex;
    align-items: center;
    margin-left: 10px;
    cursor: pointer;
    svg {
        margin-right: 5px;
    }
`;

const ShareWrap = styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    padding: 24px 48px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 5000;
`;

const ShareLink = styled.div`
    background-color: #dedede;
    width: 240px;
    font-size: 14px;
    font-weight: 300;
    padding: 2px 8px 2px 8px;
`;

const ShareCopy = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #dedede;
    cursor: pointer;
    padding: 2px 4px;
    font-weight: 500;
    min-width: 48px;
    min-height: 25px;
`;

const Finish = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 80px;
    padding: 0 5px;
    margin: 18px 8px 0 8px;
    color: #fff;
    font-size: 16px;
    background-color: #e94242;
    opacity: 0.8;
    box-shadow: 1px 2px 2px 0 rgba(153, 153, 153, 0.6);
    cursor: pointer;
`;
const Title = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    font-size: 36px;
    font-weight: 500;
    @media (max-width: 900px) {
        font-size: 24px;
    }
`;
const SubTitle = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 16px;
    font-size: 20px;
    font-weight: 300;
    @media (max-width: 900px) {
        font-size: 14px;
    }
`;
const ErrorWrap = styled.div`
    display: flex;
    /* justify-content: space-between; */
    flex-direction: column;
    align-items: center;
    min-width: 900px;
    padding: 36px;
    margin-bottom: 32px;
    background-color: #fff;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);
    color: #787878;
    @media (max-width: 900px) {
        min-width: 320px;
        margin: 0 10px;
    }
`;
const ReadMore = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 160px;
    height: 40px;
    margin-top: 24px;
    background-color: #de0606;
    font-size: 20px;
    font-weight: 500;
    color: #fff;
    cursor: pointer;
`;
const StyledSelect = styled(Select)`
    margin: ${({ margin }) => margin ? margin : ''};
`


// WEBPACK FOOTER //
// ./src/Proposal.js